import { Text } from "components/shared/text";
import { FC, PropsWithChildren } from "react";

export const Section: FC<
  PropsWithChildren<{ title?: string; index: number }>
> = ({ children, title, index }) => {
  return (
    <group
      {...(index % 2 ? { "data-background": "grey-color-xtralight" } : {})}
      data-direction="column"
    >
      <group data-direction="column" 
        {...(index > 0 ? {"data-gap":"5"} : {"data-gap":"30"})}
        data-space-vertical="50" 
        data-max-length="1440" data-position="center">
        {title && (
          <group data-direction="column"
            //data-space-vertical="20"
          >
            <Text data-text-size="x-large">{title}</Text>
          </group>
        )}
        {children}
      </group>
    </group>
  );
};
